'use client';

import * as DS from '@aurorasolar/ds';
import { ReactNode } from 'react';

type Props = { children: ReactNode; color: string };

export const Eyebrow = ({ children, color }: Props) => (
  <DS.Text color={color} fontWeight={700} letterSpacing="1.12px" text="body14" textTransform="uppercase">
    {children}
  </DS.Text>
);
